<template>
  <component 
    :is="filter.component" 
    :options="filter"
    :value="currValue"
    @update-filter="$commit.filter($event)">
  </component>
</template>

<script>
import DropdownFilter from '@/filter/DropdownFilter.vue'
import TextFilter from '@/filter/TextFilter.vue'

export default {
  name: 'BaseFilter',
  components: {
    DropdownFilter, TextFilter
  },
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  computed: {
    currValue () {
      if (this.filter.name in this.$store.params.filters) {
        return this.$store.params.filters[this.filter.name]
      }
      return null
    }
  }
}

</script>
